import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './services/sentry'; // Initialize Sentry before App mounts
import App from './App.tsx';
import AppErrorBoundary from './components/AppErrorBoundary';
import { isNativeIOS } from './utils/capacitorBridge';

// Native iOS: güvenli alan (çentik/status bar) index.css'teki html.native-ios kurallarıyla yönetilir
if (isNativeIOS()) {
  document.documentElement.classList.add('native-ios');
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>
);